// 中间件
import { middlewareService, middlewareNoTokenService } from '@/utils/axios'
import { USER_TYPE, TENANT_ID } from '@/store/mutation-types'
import { lsOptions } from '@/utils/util'

// eslint-disable-next-line no-unused-vars
let userType = 'userCenter'
// eslint-disable-next-line no-unused-vars
let tenantId = '1'

if (localStorage.getItem(`${lsOptions.namespace}${USER_TYPE}`)) {
  const type = JSON.parse(
    localStorage.getItem(`${lsOptions.namespace}${USER_TYPE}`)
  )
  userType = type.value
}
if (localStorage.getItem(`${lsOptions.namespace}${TENANT_ID}`)) {
  const data = JSON.parse(
    localStorage.getItem(`${lsOptions.namespace}${TENANT_ID}`)
  )
  tenantId = data.value
}

export const middlewareAxios = middlewareService

const api = {
  // A用户审核
  SqliteUserAuditInsert: '/sqlite/productData/userCenter/userAudit/insert', // 新增A用户审核
  SqliteUserAuditGet: '/sqlite/productData/userCenter/userAudit/filter/getPaged', // 获取数据

  // 待办
  SqliteBacklogInsert: '/sqlite/productData/userCenter/backlog/insert', // 新增数据

  // 页面配置
  pageConfiguration: {
    getPaged: '/sqlite/productData/pageConfiguration/getPaged',
    publicGetPaged: '/sqlite/productData/api/public/pageConfiguration/getPaged'
  },

  // 动态模板
  dynamicTemplateGetPaged: '/sqlite/productData/dynamicTemplate/filter/getPaged'
}

/** *************************A用户审核******************************* */
export function SqliteUserAuditInsert (params, headers) {
  return middlewareAxios({
    url: api.SqliteUserAuditInsert,
    method: 'post',
    data: params,
    headers
  })
}

export function SqliteUserAuditGet (params, headers) {
  return middlewareAxios({
    url: api.SqliteUserAuditGet,
    method: 'get',
    params: params,
    headers
  })
}
/** *************************A用户审核******************************* */

/** *************************待办******************************* */
export function SqliteBacklogInsert (params, headers) {
  return middlewareAxios({
    url: api.SqliteBacklogInsert,
    method: 'post',
    data: params,
    headers
  })
}

/** *********************** 页面配置 ******************************* */
export function SqlitePageConfigurationGetPaged (params, headers) {
  return middlewareAxios({
    url: api.pageConfiguration.getPaged,
    method: 'get',
    params,
    headers
  })
}
export function SqlitePageConfigurationPublicGetPaged (params) {
  return middlewareNoTokenService({
    url: api.pageConfiguration.publicGetPaged,
    method: 'get',
    params
  })
}

/** ************************ 页面配置 ******************************* */

/** *********************** 动态模板 ******************************* */
export function dynamicTemplateGetPaged (params, headers) {
  return middlewareAxios({
    url: api.dynamicTemplateGetPaged,
    method: 'get',
    params,
    headers
  })
}

/** *********************** 动态模板 ******************************* */
